import React from 'react';

import styles from './style.scss';


const SearchResultEmpty = () => (
  <div className={styles.wrapper}>
    <div className={styles.container}>
      <span className={styles.icon} />
      <h1>Ничего не найдено</h1>
      <p>
        К сожалению, по вашему запросу ничего не найдено. Попробуйте поискать что-нибудь другое.
      </p>
      <span className={styles.picture} />
    </div>
  </div>
);

export default SearchResultEmpty;
